<template>
	<div id="app">
		<router-view/>
	</div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
	name: 'App',
	components: {
		// HelloWorld
	}
}
</script>

<style>
#app {
	font-family: Inter, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
</style>
